<!--
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
-->

<div class="content">
  <div class="heading">{{ data.name }}</div>
  <mat-progress-spinner
    *ngIf="data.detailsState === 'loading'"
    color="primary"
    mode="indeterminate"
    diameter="50"
  ></mat-progress-spinner>
  <ng-container *ngIf="data.detailsState === 'loaded'">
    <div class="tableHeader">
      <h4>Order</h4>
      <h4>Expiration Date</h4>
    </div>
    <div class="tableBody">
      <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
          <div class="tableRow">
            <div class="order-description-container">
              <div *ngIf="isExpired(node.expiration_date)" class="expired-tag">[Expired]</div>
              <div [ngClass]="{ commItemData: true, 'expired-comm-item': isExpired(node.expiration_date) }">
                {{ node.comm_item_id }} - {{ node.description }}
              </div>
            </div>
            <div class="commItemExpiration">{{ node.expiration_date | date }}</div>
          </div>
        </mat-tree-node>
        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
          <div class="mat-tree-node">
            <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.comm_item_id">
              <mat-icon class="mat-icon-rtl-mirror">
                {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
              </mat-icon>
            </button>
            <div class="tableRow">
              <div class="order-description-container">
                <div *ngIf="isExpired(node.expiration_date)" class="expired-tag">[Expired]</div>
                <div [ngClass]="{ commItemData: true, 'expired-comm-item': isExpired(node.expiration_date) }">
                  {{ node.comm_item_id }} - {{ node.description }}
                </div>
              </div>
              <div class="commItemExpiration">{{ node.expiration_date | date }}</div>
            </div>
          </div>
          <div [class.tree-invisible]="!treeControl.isExpanded(node)" role="group">
            <ng-container matTreeNodeOutlet></ng-container>
          </div>
        </mat-nested-tree-node>
      </mat-tree>
    </div>
    <mat-paginator
      *ngIf="commItems.length > pageSize"
      [pageSize]="pageSize"
      [length]="commItems.length"
      (page)="handlePageEvent($event)"
    >
    </mat-paginator>
  </ng-container>
  <div class="footer">
    <div class="contact">Contact your Wind River Account Manager with any order questions.</div>
    <button mat-raised-button (click)="close()">close</button>
  </div>
</div>
